import PropTypes from 'prop-types';
import React from 'react';
import { hot } from 'react-hot-loader/root';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import BackToTop from '@bibliocommons/base-back-to-top';
import { TOGGLZ_FEATURES } from '@bibliocommons/constants-feature-togglz';
import FeatureTogglz from '@bibliocommons/feature-togglz';

import { DataLayerContainer } from 'app/components/analytics/DataLayer';
import CoreHeaderContainer from 'app/containers/CoreHeaderContainer';
import { DocumentHeadContainer } from 'app/components/shared/DocumentHead';
import FooterContainer from 'app/containers/FooterContainer';
import GlobalProgressBarContainer from 'app/containers/GlobalProgressBarContainer';
import GlobalMessagingContainer from 'app/containers/shared/Messaging/GlobalMessagingContainer';
import InternalErrorContainer from 'app/containers/InternalErrorContainer';
import LoginOverlayContainer from 'app/containers/LoginOverlayContainer';
import StaffTakeoverContainer from 'app/containers/StaffTakeoverContainer';
import ScreenReaderNavigationContainer from 'app/containers/ScreenReaderNavigationContainer';
import { SystemMessagesContainer } from 'app/components/shared/SystemMessages';

let MainLayout = null;

if (__SERVER__ || __ENHANCED_ASSETS__) {
  // eslint-disable-next-line global-require
  MainLayout = require('app/components/layouts/MainLayout').default;
} else {
  // eslint-disable-next-line global-require
  require('app/deprecated/assets/stylesheets/app.scss');
}

/** @extends React.Component */
class MainLayoutDeprecated extends BcReactComponent {
  renderDeprecated() {
    return (
      <div>
        <DataLayerContainer />
        <DocumentHeadContainer />
        <ScreenReaderNavigationContainer />
        <GlobalProgressBarContainer />
        <StaffTakeoverContainer />
        <CoreHeaderContainer />
        <div id="preview-bar" />
        <SystemMessagesContainer />
        <div id="content" tabIndex="-1">
          <InternalErrorContainer>{this.props.children}</InternalErrorContainer>
        </div>
        <GlobalMessagingContainer />
        <LoginOverlayContainer />
        <FooterContainer />
        <BackToTop />
      </div>
    );
  }

  renderEnhanced() {
    return <MainLayout {...this.props} />;
  }

  render() {
    return (
      <FeatureTogglz>
        {features =>
          features.get(TOGGLZ_FEATURES.NERF_GLOBAL_UI_UPDATES) ? this.renderEnhanced() : this.renderDeprecated()
        }
      </FeatureTogglz>
    );
  }
}

MainLayoutDeprecated.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

export default hot(MainLayoutDeprecated);
